<template >
  <div
    v-if="
      (option.isAdmin && isAdmin && !currentBranch) ||
      (option.isModirAdmin && isModirAdmin) ||
      (option.isReporter && isReporter) ||
      (option.isModir && isModir) ||
      (option.isHesabdar && isHesabdar) ||
      (option.isAshpaz && isAshpaz) ||
      (option.isEnduser && isEnduser)
    "
  >
    <app-option
      v-if="option.route"
      :icon="option.icon"
      :title="option.title"
      :route="option.route"
      :value="option.value"
      @closeSlider="$emit('closeSlider')"
    />
    <template v-else-if="showHeader">
      <app-title :title="option.title" />
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import router from "@/router";
import SliderTitle from "./Title";
import SliderOption from "./Option";

export default {
  props: ["option", "showHeader"],
  components: {
    appTitle: SliderTitle,
    appOption: SliderOption,
  },

  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isReporter() {
      return this.$store.getters.isReporter;
    },
    isModir() {
      return this.$store.getters.isModir;
    },
    isHesabdar() {
      return this.$store.getters.isHesabdar;
    },
    isAshpaz() {
      return this.$store.getters.isAshpaz;
    },
    isEnduser() {
      return this.$store.getters.isEnduser;
    },
    isModirAdmin() {
      return this.$store.getters.isModirAdmin;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
  },
};
</script>
<style scoped>
.options {
  display: block;
  padding: 0px;
  cursor: pointer;
}
</style>
